import axios from "axios";
import { add } from "date-fns";
import { stringify } from "query-string";
import { DataProvider } from "react-admin";
import {
  getRawUrlBase,
  PlanningResourcesEnum,
  RteCommunicationV2ResourcesEnum,
  SiteResourcesEnum,
} from "shared/enums/resourceMappings";
import { GroupType } from "shared/types";
import { DefaultAfrrChronicleFilenameEnum } from "./types";

export const fetchGroup = async (group_id: number, dataProvider: DataProvider) => {
  try {
    const result = await dataProvider.getOne(SiteResourcesEnum.Groups, {
      id: group_id,
    });
    const data = result.data as unknown as GroupType;
    if (!data) throw new Error("Could not fetch group");
    return data;
  } catch (error: unknown) {
    return { error: `Error fetching group: ${(error as Error).message}` };
  }
};

export const fetchMasks = async (startingDate: Date, endingDate: Date, group: GroupType) => {
  try {
    const query = stringify({
      start_date: startingDate.toISOString(),
      end_date: endingDate.toISOString(),
      site_id__in: group?.site_ids.toString(),
      page: 1,
      size: 100,
    });

    const { data } = await axios.get(`${getRawUrlBase(PlanningResourcesEnum.PlanningMasks)}trimmed/?${query}`, {
      timeout: 10000,
    });
    return data;
  } catch (error: any) {
    return { error: `Error fetching masks: ${error.message}` };
  }
};

export const fetchR2ChroniclesGroupMasks = async (startingDate: Date, groupId: number, dataProvider: DataProvider) => {
  const group = await fetchGroup(groupId, dataProvider);
  if ("error" in group) throw new Error("Could not fetch group");

  const masksResp = await fetchMasks(startingDate, add(startingDate, { hours: 4 }), group);
  if ("error" in masksResp) throw new Error("Could not fetch masks");

  const { items: masks } = masksResp;
  return { masks, group };
};

// TODO: enhance data type
export const postPlannings = async (data: Record<string, any>) => {
  const url = `${getRawUrlBase(PlanningResourcesEnum.Plannings)}`;
  return await axios({
    method: "post",
    url,
    data,
  });
};

interface PostIecConfigsProps {
  start_date: Date;
  end_date: Date;
  group_id: number;
  test_file_path: DefaultAfrrChronicleFilenameEnum | string;
}

export const postIecConfig = async (preparedData: PostIecConfigsProps, dataProvider: DataProvider) => {
  return dataProvider.create(RteCommunicationV2ResourcesEnum.RteCommunicationTestConfig, {
    data: { ...preparedData, type: "nlevel_simulation" },
  });
};

export const postIecConfigs = async (configs: PostIecConfigsProps[], dataProvider: DataProvider) => {
  return await Promise.allSettled(configs.map((config) => postIecConfig(config, dataProvider)));
};
